export const assertIfUndefined = (obj: { [key: string]: any }) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] == null) {
      throw new Error(`${key} must be set`);
    }
  });
};
